<template>
  <div id="comingSoon" class="p-2 mt-5">
      <h1>PRÓXIMAMENTE</h1>
      <div class="p-0 d-flex flex-wrap col-12">
          <div v-for="(item,index) in modules" :key="index" class="col-3 p-2">
              <div class="p-2 d-flex justify-content-center align-items-center card flex-row">
                  <div class="col-3">
                      <img :src="require('@/assets/images/icons/' + item.img + '.svg')" alt="" width="100%">
                  </div>
                  <div class="col-9 p-2">
                      <h4 class="font-weight-bold">{{item.name}}</h4>
                        <b-alert class="p-2 m-0" show :variant="item.colorStatus"><p class="m-0">{{item.status}}</p></b-alert>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            modules:[
                {name:'Ausentismos',img:'event_seat_2',status:'Ya Disponible',colorStatus:'success'},
                {name:'Historicos laborales',img:'history',status:'Disponible en pocas semanas',colorStatus:'secondary'},
                {name:'Condiciones de salud',img:'accessible',status:'Disponible en pocas semanas',colorStatus:'secondary'},
                {name:'Factores de salud',img:'stethoscope',status:'Disponible en pocas semanas',colorStatus:'secondary'},
                {name:'Remisiones actuales',img:'directions',status:'Disponible en pocas semanas',colorStatus:'secondary'},
                {name:'Recomendaciones y Restricciones Médicas ',img:'lightbulb',status:'Disponible en pocas semanas',colorStatus:'secondary'},
                {name:'Atención Asistencial de Accidentes Laborales',img:'healing',status:'Disponible en pocas semanas',colorStatus:'secondary'},
            ]
        }
    },
}
</script>

<style lang="scss">
#comingSoon{
    box-sizing: border-box;
    p{
        font-size: 10px;
    }
}
</style>